module.exports = __webpack_public_path__ + "img/leaf-right2.8e5a8539.png";